import React from 'react';

import { ScrollView } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';

import { Section } from 'components/features/home-page/styles';
import { CenteredRowContainer } from 'components/layout/centered-row-container';
import { MarketingTileSkeleton } from 'components/marketing-tile/marketing-tile.skeleton';
import { HeroSkeleton } from 'components/ucl/hero/hero.skeleton';
import { spacing } from 'styles/constants';

export const HomePageSkeleton = React.memo(() => {
  return (
    <ScrollView>
      <HeroSkeleton />
      <CenteredRowContainer standardPadding containerStyle={styles.cardsContainer}>
        <Section first last shouldRenderDefaultBackground>
          <MarketingTileSkeleton />
        </Section>
      </CenteredRowContainer>
    </ScrollView>
  );
});

const styles = StyleSheet.create({
  cardsContainer: {
    marginTop: spacing.$4,
  },
});
